export const LOGIN_FORM = 'LOGIN_FORM';
export const FORGOT_PASSWORD_FORM = 'FORGOT_PASSWORD_FORM';
export const SIGNUP_FORM = 'SIGNUP_FORM';
